import React from 'react';

function PendingTransactions() {
  return (
    <svg width='32' height='32' fill='none' viewBox='0 0 32 32'>
      <rect width='32' height='32' fill='#FFFBE6' rx='8'></rect>
      <path
        fill='#FAAD14'
        stroke='#FAAD14'
        strokeWidth='0.2'
        d='M16 9.4c-4.36 0-7.9 3.54-7.9 7.9s3.54 7.9 7.9 7.9 7.9-3.54 7.9-7.9-3.54-7.9-7.9-7.9zm0 1.5c3.534 0 6.4 2.866 6.4 6.4s-2.866 6.4-6.4 6.4-6.4-2.866-6.4-6.4 2.866-6.4 6.4-6.4z'></path>
      <path fill='#FAAD14' stroke='#FAAD14' strokeWidth='0.2' d='M16 10.25a.75.75 0 01.75.75v4l2 2a.75.75 0 11-1.06 1.06l-2.22-2.22a.75.75 0 01-.22-.53v-4a.75.75 0 01.75-.75z'></path>
    </svg>
  );
}

export default PendingTransactions;
